import type { AppIconProps } from "../IconTypes";

export const FolderIcon: React.FC<AppIconProps> = ({
  width = 16,
  height = 16,
  className,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M8 12.6667H3.33333C2.97971 12.6667 2.64057 12.5263 2.39052 12.2762C2.14048 12.0262 2 11.687 2 11.3334V4.00008C2 3.64646 2.14048 3.30732 2.39052 3.05727C2.64057 2.80722 2.97971 2.66675 3.33333 2.66675H6L8 4.66675H12.6667C13.0203 4.66675 13.3594 4.80722 13.6095 5.05727C13.8595 5.30732 14 5.64646 14 6.00008V8.33341M10.6667 12.6667H14.6667M12.6667 10.6667V14.6667"
        stroke="#1D9F81"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
